<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert')">Carl Von
                        Schubert
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/egon-muller')">Egon Müller
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/jj-prum')">J.J. Prüm
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/peter-lauer')">Peter Lauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/van-volxem')">Van Volxem
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken')">
                        Weingut Forstmeister Geltz Zilliken
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch')">Wwe. Dr. H.
                        Thanisch, Erben Thanisch
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Weingut Forstmeister Geltz Zilliken</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La moda, per sua stessa natura, è transitoria. Alcuni stili sono tendenze, qui un minuto, andato il
                        poi, mentre altri sono destinati a diventare dei classici; pensa al tubino nero di Audrey Hepburn o
                        Il tailleur in tweed di Coco Chanel. E alcune cose è meglio non toccarle. Conosciuto semplicemente come “Zliken”,
                        I grandi Riesling di Weingut Forstmeister Geltz Zilliken sono una di quelle cose. Senza tempo
                        tradizionale, ma sempre attuale, Ziliken è l'Hemmingway del mondo del vino.
                    </div>

                    <div class="howto-title2">Lo zar della Saar</div>
                    <div class="howto-text">
                        Fai clic sulla home page di Ziliken e vedrai una frase "Per produrre vini Riesling come i nostri abbiamo bisogno
                        una cosa soprattutto. Pazienza". Questo riassume praticamente la filosofia di Ziliken, perché affrettarsi
                        qualcosa quando puoi dedicarci del tempo? E dovrebbero saperlo; la vigna ha sofferto
                        alcuni sconvolgenti abusi in passato. Divisa nel 1925 e distrutta nel 1944, la tenuta avrebbe potuto avere
                        sarebbe stato facilmente lasciato in rovina se non fosse stato per Marianne Geltz-Zliken (proprietario originale Ferdinand
                        nipote di Getz). La sua determinazione a ripristinare il suo diritto di nascita consumava tutto
                        1950, lei (insieme al marito Fritz Ziliken) aveva acquistato una cantina a due piani e aveva iniziato
                        reimpianto delle viti. Benedetta dai climi freddi della superlativa regione della Saar, quella di Marianne
                        i vigneti erano ripidi e esposti a sud, abbastanza per dare ai suoi vini un vantaggio rispetto alla concorrenza. In
                        1976 Il figlio di Marianne, Annone, inizia come cantiniere nella tenuta, assumendone la piena proprietà nel 1981.
                        Sotto la sua guida, Annone riportò la tenuta alla sua dimensione originaria, tutti gli 11 ettari.
                    </div>

                    <div class="howto-title2">Nessun compromesso sulla qualità</div>
                    <div class="howto-text">
                        La figlia di Hanno, Dorothee, ora ha il controllo. "Facciamo una cosa - Riesling - e lo facciamo bene",
                        dice Dorothee, e perbacco, ha ragione. I vini sono ottimi esempi di Saar Riesling;
                        teso in modo appetitoso, minerale e sofisticato. Non ci sono compromessi quando si tratta di
                        qualità; agli Ziliken piace fare le cose come sono sempre state fatte. Niente di più, niente
                        meno. I loro 28 vini diversi sono sorprendentemente economici; un mezzo caso dell'ottimo 2017
                        Saarburger Rausch, Riesling, Kabinett possono essere ritirati per circa € 100, mentre il superiore
                        Spätlese è poco più di € 150 per 6 bottiglie. I magnum di questa tenuta sono particolarmente
                        glorioso, il Goldkap 2010, Auslese Riesling è piuttosto notevole e dovrebbe offrire un suono
                        potenziale di investimento.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Nell'ambito di una vendita da record per i TBA della Mosella nel settembre 2015 all'asta di vini VDP Pradikat, Treviri, il Rausch TBA del 2005 di Weingut Forstmeister Geltz-Zilliken è stato venduto a 2.910 euro per magnum.
                            </li>
                            <li>Saarburger Rausch Riesling Eiswein viene prodotto quando possibile, a partire dai prezzi del secondo trimestre 2019
                                con una media di € 695 (tutte le annate, per bottiglia) e ha registrato una tendenza al rialzo nel passato
                                anno.
                            </li>
                            <li>Dall'entry level al Grosse Lage, tutti i vini Forstmeister Geltz-Zilliken sono 100% di proprietà
                                cresciuto e imbottigliato.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Weingut Forstmeister Geltz Zilliken</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Mode ist von Natur aus vergänglich. Einige Stile sind Trends, hier ist der Moment vorbei
                        als nächstes, während andere dazu bestimmt sind, Klassiker zu werden; Denken Sie an Audrey Hepburns kleines Schwarzes oder
                        Der Tweedanzug von Coco Chanel. Und manche Dinge sollte man besser unangetastet lassen. Einfach als „Ziliken“ bekannt.
                        Die großartigen Rieslinge des Weingut Forstmeister Geltz Zilliken sind eines dieser Dinge. Zeitlos
                        Traditionell und doch immer aktuell: Ziliken ist der Hemmingway der Weinwelt.
                    </div>

                    <div class="howto-title2">Der Zar von Saar</div>
                    <div class="howto-text">
                        Klicken Sie auf die Homepage von Ziliken und Sie werden einen Satz sehen: „Um Rieslingweine wie unseren herzustellen, brauchen wir.“
                        vor allem eines. Geduld". Das fasst die Ziliken-Philosophie ziemlich gut zusammen: Warum Eile?
                        etwas, bei dem man sich Zeit lassen kann? Und sie sollten es wissen; Der Weinberg hat gelitten
                        einige schockierende Misshandlungen in der Vergangenheit. Das 1925 geteilte und 1944 zerstörte Anwesen könnte entstanden sein
                        Ohne Marianne Geltz-Zilikens (ursprünglicher Besitzer Ferdinand) wäre es leicht dem Verfall preisgegeben worden
                        Getz‘ Enkelin). Ihre Entschlossenheit, ihr Erstgeburtsrecht wiederherzustellen, war allumfassend
                        1950 hatte sie (zusammen mit ihrem Mann Fritz Ziliken) einen zweistöckigen Keller gekauft und damit begonnen
                        Neupflanzung der Reben. Gesegnet mit dem kühlen Klima der Saarregion der Superlative, Marianne’s
                        Die Weinberge waren steil und nach Süden ausgerichtet, was ihren Weinen einen Vorsprung gegenüber der Konkurrenz verschaffte. In
                        1976 begann Mariannes Sohn Hanno als Kellermeister auf dem Weingut und übernahm 1981 das alleinige Eigentum.
                        Unter seiner Leitung stellte Hanno das Anwesen wieder auf seine frühere Größe her, insgesamt 11 Hektar.
                    </div>

                    <div class="howto-title2">Keine Kompromisse bei der Qualität</div>
                    <div class="howto-text">
                        Hannos Tochter Dorothee hat nun die Kontrolle. „Wir machen eines – Riesling – und wir machen es richtig“,
                        sagt Dorothee, und bei Gott, hat sie recht? Die Weine sind Paradebeispiele des Saarrieslings;
                        Herrlich straff, mineralisch und raffiniert. Beim Thema gibt es keine Kompromisse
                        Qualität; Die Zilikens mögen es, Dinge so zu tun, wie sie es immer getan haben. Nichts mehr, nichts
                        weniger. Ihre 28 verschiedenen Weine sind überraschend günstig; eine halbe Kiste des hervorragenden 2017
                        Den Saarburger Rausch, Riesling, Kabinett gibt es für rund 100 Euro, den Superior
                        Spätlese kostet etwas über 150 € für 6 Flaschen. Besonders hervorzuheben sind die Magnums aus diesem Nachlass
                        Herrlich, der 2010 Goldkap, Auslese Riesling ist ziemlich bemerkenswert und sollte Klang bieten
                        Investitionspotenzial.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Im Rahmen eines Rekordverkaufs für Mosel-TBAs im September 2015 bei der Weinauktion VDP Pradikat in Trier erzielte Weingut Forstmeister Geltz-Zillikens Rausch TBA 2005 2.910 € pro Magnum.
                            </li>
                            <li>Saarburger Rausch Riesling-Eiswein wird nach Möglichkeit zum Preis von Q2 2019 produziert
                                Durchschnittlich 695 € (alle Jahrgänge, pro Flasche) und in der Vergangenheit tendenziell steigend
                                Jahr.
                            </li>
                            <li>Von der Einstiegsklasse bis zur Großen Lage sind alle Weine von Forstmeister Geltz-Zilliken zu 100 % vom Weingut
                                angebaut und abgefüllt.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Weingut Forstmeister Geltz Zilliken</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La mode, de par sa nature même, est éphémère. Certains styles sont des tendances, ici une minute, fini le
                        ensuite, tandis que d'autres sont voués à devenir des classiques ; pensez à la petite robe noire d'Audrey Hepburn ou
                        Le tailleur en tweed de Coco Chanel. Et il vaut mieux laisser certaines choses intactes. Connu simplement sous le nom de "Ziliken",
                        Les grands rieslings de Weingut Forstmeister Geltz Zilliken en font partie. Intemporel
                        traditionnel, mais toujours d'actualité, Ziliken est le Hemmingway du monde du vin.
                    </div>

                    <div class="howto-title2">Le Tsar de Sarre</div>
                    <div class="howto-text">
                        Cliquez sur la page d'accueil de Ziliken et vous verrez une phrase "Pour faire des vins de Riesling comme les nôtres, nous avons besoin
                        une chose avant tout. Patience". Cela résume à peu près la philosophie Ziliken, pourquoi se précipiter
                        quelque chose quand vous pouvez prendre votre temps dessus ? Et ils devraient savoir; le vignoble a souffert
                        certains abus choquants dans le passé. Divisé en 1925 et détruit en 1944, le domaine aurait pu
                        facilement été laissé à la ruine s'il n'y avait pas eu Marianne Geltz-Ziliken (propriétaire d'origine Ferdinand
                        petite-fille de Getz). Sa détermination à restaurer son droit d'aînesse était dévorante et par
                        1950, elle (avec son mari Fritz Ziliken) avait acheté une cave à deux étages et avait commencé
                        replanter les vignes. Bénéficiant des climats frais de la région superlative de la Sarre, Marianne's
                        les vignobles étaient escarpés et orientés au sud, suffisamment pour donner à ses vins l'avantage sur leurs concurrents. Dans
                        1976 Le fils de Marianne, Hanno, a commencé comme maître de chai au domaine, en prenant la pleine propriété en 1981.
                        Sous sa gouverne, Hanno a restauré le domaine à son ancienne taille, tous les 11 hectares.
                    </div>

                    <div class="howto-title2">Aucun compromis sur la qualité</div>
                    <div class="howto-text">
                        La fille d'Hanno, Dorothée est désormais aux commandes. "Nous faisons une chose - Riesling - et nous le faisons bien",
                        dit Dorothée, et bon sang, elle a raison. Les vins sont d'excellents exemples de Saar Riesling;
                        tendu, minéral et sophistiqué. Il n'y a pas de compromis quand il s'agit de
                        qualité; les Ziliken aiment faire les choses comme elles ont toujours été faites. Rien de plus, rien
                        moins. Leurs 28 vins différents sont étonnamment bon marché ; une demi-caisse de l'excellent 2017
                        Saarburger Rausch, Riesling, Kabinett peuvent être ramassés pour environ 100 €, tandis que le supérieur
                        Spätlese est un peu plus de 150 € pour 6 bouteilles. Les magnums de ce domaine sont particulièrement
                        glorieux, le Goldkap 2010, Auslese Riesling est tout à fait remarquable et devrait offrir du son
                        potentiel d'investissement.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Dans le cadre d'une vente record de Mosel TBAs en septembre 2015 lors de la vente aux enchères de vins VDP Pradikat à Trèves, le Rausch TBA 2005 de Weingut Forstmeister Geltz-Zilliken a rapporté 2 910 € le magnum.
                            </li>
                            <li>Le Saarburger Rausch Riesling Eiswein est produit lorsque cela est possible, aux prix du T2 2019
                                en moyenne 695 € (tous millésimes, par bouteille) et a connu une tendance à la hausse au cours des dernières années
                                année.
                            </li>
                            <li>De l'entrée de gamme à la Grosse Lage, tous les vins Forstmeister Geltz-Zilliken sont 100% du domaine
                                cultivé et mis en bouteille.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Weingut Forstmeister Geltz Zilliken</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Fashion, by its very nature is transient. Some styles are trends, here one minute, gone the
                        next, while others are destined to become classics; think Audrey Hepburn’s little black dress or
                        Coco Chanel’s tweed suit. And some things are better left untouched. Known simply as “Ziliken”,
                        Weingut Forstmeister Geltz Zilliken’s great Rieslings are one of those things. Timelessly
                        traditional, yet always relevant, Ziliken is the Hemmingway of the wine world.
                    </div>

                    <div class="howto-title2">The Tsar of Saar</div>
                    <div class="howto-text">
                        Click on Ziliken’s homepage and you’ll see one phrase “To make Riesling wines like ours we need
                        one thing above all. Patience”. That pretty much sums up the Ziliken philosophy, why rush
                        something when you can take your time over it? And they should know; the vineyard has suffered
                        some shocking abuse in the past. Divided in 1925 and destroyed in 1944, the estate could have
                        easily been left to ruin had it not been for Marianne Geltz-Ziliken’s (original owner Ferdinand
                        Getz’s granddaughter). Her determination to restore her birthright was all-consuming and by
                        1950, she (along with her husband Fritz Ziliken) had purchased a two-story cellar, and had begun
                        replanting the vines. Blessed with the cool climates of the superlative Saar region, Marianne’s
                        vineyards were steep and south-facing, enough to give her wines the edge over competitors. In
                        1976 Marianne’s son Hanno started as cellarmaster at the estate, taking full ownership in 1981.
                        Under his steerage, Hanno restored the estate to its former size, all 11-hectares of it.
                    </div>

                    <div class="howto-title2">No compromises on quality</div>
                    <div class="howto-text">
                        Hanno’s daughter, Dorothee is now in control. “We do one thing — Riesling — and we do it right”,
                        says Dorothee, and by golly, is she right. The wines are prime examples of Saar Riesling;
                        mouthwateringly taut, mineral and sophisticated. There are no compromises when it comes to
                        quality; the Zilikens like to do things as they have always been done. Nothing more, nothing
                        less. Their 28 different wines are surprisingly inexpensive; a half case of the excellent 2017
                        Saarburger Rausch, Riesling, Kabinett can be picked up for around €100, while the superior
                        Spätlese is a little over €150 for 6 bottles. The magnums from this estate are particularly
                        glorious, the 2010 Goldkap, Auslese Riesling is quite remarkable and should offer sound
                        investment potential.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>As part of a record breaking sale for Mosel TBAs in September 2015 at the VDP Pradikat wine auction, Trier, Weingut Forstmeister Geltz-Zilliken’s 2005 Rausch TBA fetched €2,910 per magnum.
                            </li>
                            <li>Saarburger Rausch Riesling Eiswein is produced when possible, as of Q2 2019 prices
                                averaging €695 (all vintages, per bottle) and has been trending upwards over the past
                                year.
                            </li>
                            <li>From entry level to Grosse Lage, all Forstmeister Geltz-Zilliken wines are 100% estate
                                grown and bottled.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WeingutForstmeisterGeltzZilliken",
    data() {
        return {
            select: {
                report: 'Weingut Forstmeister Geltz Zilliken',
                src: '/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken'
            },
            items: [
                {report: 'Carl Von Schubert', src: '/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert'},
                {report: 'Egon Müller', src: '/wine-guide/germany/mosel-saar-ruwer/egon-muller'},
                {report: 'J.J. Prüm', src: '/wine-guide/germany/mosel-saar-ruwer/jj-prum'},
                {report: 'Peter Lauer', src: '/wine-guide/germany/mosel-saar-ruwer/peter-lauer'},
                {report: 'Van Volxem', src: '/wine-guide/germany/mosel-saar-ruwer/van-volxem'},
                {
                    report: 'Weingut Forstmeister Geltz Zilliken',
                    src: '/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken'
                },
                {
                    report: 'Wwe. Dr. H. Thanisch, Erben Thanisch',
                    src: '/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Weingut Forstmeister Geltz Zilliken | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the art of winemaking at Weingut Forstmeister Geltz Zilliken, a renowned wine producer in the Mosel region. Experience the unique flavors and rich traditions of German wine.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
